import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import PrincipalHistorizationSelectionViewModel from '@/ViewModels/Controls/PrincipalHistorizationSelectionViewModel';
import PrincipalHistorizationSelection from '@/Controls/PrincipalHistorizationSelection';

export default class PrincipalHistorizationSelectionFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private PrincipalHistorizationSelectionViewModel = ComponentManager.getViewModel<typeof PrincipalHistorizationSelectionViewModel>('PrincipalHistorizationSelectionViewModel');
    private PrincipalHistorizationSelection = ComponentManager.getControl<typeof PrincipalHistorizationSelection>('PrincipalHistorizationSelection');

    /**
     * @override
     */
    public viewModel: PrincipalHistorizationSelectionViewModel;

    public constructor(params: any) {
        super(params);
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = new this.PrincipalHistorizationSelectionViewModel({
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            invalidationText: this.invalidationText
        });

        this.control = new this.PrincipalHistorizationSelection(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        return this.jQueryControl;
    }
}

ComponentManager.setFactory('PrincipalHistorizationSelection', PrincipalHistorizationSelectionFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');